import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { UnitsModel, PageResultDto,AreaSearchFields } from '../../common/viewModels/GlobalRegistry/UnitsModel';
import { ToastrService } from 'ngx-toastr';
import { PagerService } from '../../common/pagerService';
declare var $: any;
@Component({
  selector: 'area',
  templateUrl: './Area.component.html',
  styleUrls: ['./Area.component.scss']
})
export class AreaComponent implements OnInit {
  areaForm: FormGroup;
  areaSearchForm: FormGroup;
  id: number;
  unitId: number;
  UnitsDto: UnitsModel;
  searchFields: AreaSearchFields = new AreaSearchFields();
  isNoRecords: boolean = true;
  isSubmitted: boolean = false;
  pager: any = {};
  pagedItems: any[];
  pageResult: PageResultDto;
  length: number = 0;
  mainComponent: any;
  //pager:Pager=new Pager();
  $element: any;
  $content: any;

  constructor(public _router: Router, private _formBuilder: FormBuilder, private _pagerService: PagerService,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _toastrService: ToastrService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    this.pager.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
    this.CreateForm();
    this.areaSearchForm = this._formBuilder.group({
      Name: [''],
      AreaId: [0],
    });
    this.BindStaticSearchData();
    this.setPage(this.pager);
    //this.unitForm.controls['Name'].setValidators(Validators.required);
  }

  CreateForm() {
    this.areaForm = this._formBuilder.group({
      AreaId: [0],
      Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
    });
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pagerService.pageSize;
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetAreasList(this.pager);
  }

  GetAreasList(page: any) {
    
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetAreaList, this.searchFields)
      .subscribe(
      res => {
        var data = res.json();
        this.length = data.PageResult.TotalRecords;
        this.pagedItems = data.Result;
        this.isNoRecords = !(data.Result.length > 0);
        this._mApp.HideLoader();
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  GetAreaById(id: number) {
    this._mApp.ShowLoader();
    this.unitId = id;
    this._http.get(this._appUrl.GetAreaByAreaId + id)
      .subscribe(
      m => {
        this._mApp.HideLoader();
        if (m.json().Result != null) {
          this.areaForm.setValue(m.json().Result);
        }
      }, error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      )
  }

  DeleteArea(id: any) {
      
    this.id = id;
  }

  DeleteAreasById(id: number) {
      
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteArea + id)
      .subscribe(
      res => {
        this._mApp.HideLoader();
        this.setPage(this.pager);
        this._toastrService.success(res.json().Result, '');

      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  onSearchSubmit() {
    this.pager.pageIndex = 0;
    let searchDto = this.areaSearchForm.value;
    if (searchDto.Name != null)
      this.searchFields.Name = searchDto.Name;
    this.setPage(this.pager);
  }

  onSubmit() {
    this.areaForm.get('Name').setValidators(Validators.compose([ Validators.required, Validators.minLength(1), Validators.maxLength(50)]));
    this.areaForm.get('Name').updateValueAndValidity();
    this.isSubmitted = true;
    if (this.areaForm.valid) {
      let areaDto = this.areaForm.value;
      this._mApp.ShowLoader();
      if(areaDto.AreaId==null || areaDto.AreaId==0)
      {
        areaDto.AreaId=0;
      }
      this._http.post(this._appUrl.UpsertArea, areaDto)
        .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, '');
          $('#addUnitModel').modal('toggle');
          this.Clear();
          this.setPage(this.pager);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
        );
    }
    else {
      //$('#unitName').addClass("mat-input-invalid");
    }
  }

  Clear() {
    this.areaForm.get('Name').setValidators(Validators.compose([ Validators.minLength(1), Validators.maxLength(50)]));
    this.areaForm.get('Name').updateValueAndValidity();
    this.areaForm.reset();        
    //this.CreateForm();
    //this.RemoveInvalidCSS();
  } 

  OnReset() {
    this.areaSearchForm.reset();
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.searchFields.Name = '';
    this.setPage(this.pager);
  }
  
}
